import { Component, ElementRef, OnDestroy } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription } from "rxjs";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxBlotterActionEvent } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterOpsIntContextMenuItemState } from "../bfx-blotter-ops-int/models/contextmenu/BfxBlotterOpsIntContextMenuItemState";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxDialogData } from "./models/bfx-dialog-data.model";
import { BfxOpsIntDialogsProcessorService } from "./services/bfx-ops-int-dialogs-processor.service";

@Component({
  selector: "bfx-dialog-ops-int-clear-confirm",
  templateUrl: "./html/bfx-dialog-ops-int-clear-confirm.html",
  standalone: false,
})
export class BfxDialogOpsIntClearConfirmComponent
  extends BfxDialogBaseComponent
  implements OnDestroy
{
  public config: any = {
    debug: false,
  };

  public manualDealRefValid: boolean = false;
  public manualDealRefEmpty: boolean = true;
  public manualDealRefIsInvalid: boolean = false;
  public clearCommentInvalid: boolean = false;
  private orderType: string = "";
  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    itemState: new BfxBlotterOpsIntContextMenuItemState(),
    dialogData: {
      show: false,
      width: 450,
      title_template: "",
      title_text: null,
      message_text: null,
      placeholder: "Clear Comment",
      event: null,
      referencedDataIDs: null,
      refs: null,
      referencedOpsIntDataIDs: null,
      nonDialogReferenceOpsIntIds: [],
      manualDealRef: null,
      comment: null, // model
      valid: false,
      message_manual_def_ref_invalid: "Manual Def Ref is not valid.",
    },
  };

  private configurationSubscription: Subscription;

  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    private _opsIntProcessorService: BfxOpsIntDialogsProcessorService,
    private _element: ElementRef,
  ) {
    super();
    this.subscribeToConfiguration();
  }

  ngOnDestroy() {
    this.configurationSubscription.unsubscribe();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<BfxDialogData> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;
      this.data.itemState = _dialogData.event.itemState;
      this.data.dialogData.referencedOpsIntDataIDs = this.data.itemState.referencedOpsIntIds;
      this.data.dialogData.title_template = _dialogData.payload.title;
      this.data.dialogData.referencedDataIDs = _dialogData.payload.clearDialogReferencedIds;
      this.data.dialogData.refs = _dialogData.payload.refs;

      let event: BfxBlotterActionEvent = this.data.actionEvent;

      if (event != null) {
        // title
        let title_text = this.data.dialogData.title_template;
        // message text
        let message_text: string = "";

        // assign values and show the dialog
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
        this.assignValuesAndShowWarningDialog(title_text, message_text);
      } else {
        logger.out.error(
          "ERROR: BfxDialogOpsIntClearConfirmComponent.openTradeCancelConfirmDialog(): Invalid event payload= ",
          event,
        );
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogOpsIntClearConfirmComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }
    return this.data.dialogEventSubject.asObservable();
  }

  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config.debug = config.general.debug;
    });
  }

  public closeDialog() {
    super.closeDialog();
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.itemState = null;
    this.data.dialogData.referencedDataIDs = null;
    this.data.dialogData.refs = null;
    this.data.dialogData.title_template = null;
    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;

    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public validateManualDealRef($event) {
    this.manualDealRefValid = $event.query.length != 0;
    this.manualDealRefEmpty = this.manualDealRefIsInvalid = $event.query.length == 0;
  }
  public onFocusManualDealRef($event) {
    this.manualDealRefIsInvalid = false;
  }
  public validateManualDealRefOnBlur($event) {
    this.manualDealRefValid = $event.target.value.length != 0;
    this.manualDealRefEmpty = this.manualDealRefIsInvalid = $event.target.value.length == 0;
  }

  public onFocusClearComment($event) {
    this.clearCommentInvalid = false;
  }

  public validateClearCommentOnBlur($event) {
    this.clearCommentInvalid =
      !this.data.dialogData.comment ||
      this.data.dialogData.comment.length < 1 ||
      this.data.dialogData.comment.length > 250;
  }

  public isSubmitDisabled() {
    return (
      !this.data.dialogData.comment ||
      this.data.dialogData.comment.length < 1 ||
      this.data.dialogData.comment.length > 250 ||
      this.manualDealRefEmpty
    );
  }

  public actionClearOpsInt_submit() {
    if (!this.isSubmitDisabled()) {
      let event = {
        referencedOpsIntIds: this.data.dialogData.referencedOpsIntDataIDs,
        comments: this.data.dialogData.comment,
        externalDealId: this.data.dialogData.manualDealRef,
      };
      this._opsIntProcessorService.executeClear(event);
      this.closeDialog();
    } else {
      logger.out.warn(
        "WARNING: BfxDialogOpsIntClearConfirmComponent.actionClearOpsInt_submit(): Comment length out of bounds, comment= " +
          this.data.dialogData.comment,
      );
      logger.out.warn(
        "WARNING: BfxDialogOpsIntClearConfirmComponent.actionClearOpsInt_submit(): Manual Deal Ref not a number, manualDealRef= " +
          this.data.dialogData.manualDealRef,
      );
      this.data.dialogData.valid = false;
    }
  }

  public actionClearOpsInt_cancel() {
    this.closeDialog();
  }

  private assignValuesAndShowWarningDialog(title_text: string, message_text: string): void {
    // assign values
    this.data.dialogData.title_text = title_text;
    this.data.dialogData.message_text = message_text;
    // show the dialog
    this.data.dialogData.show = true;
  }
}
